import React from 'react';

export const LoadingState: React.FC = () => {
  return (
    <div className="page-container flex items-center justify-center">
      <div className="text-center animate-fade-in">
        <div className="w-12 h-12 mx-auto mb-4 spinner"></div>
        <p className="text-gray-600 font-medium">Loading layout...</p>
      </div>
    </div>
  );
};
